import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import UserProducts from "./common/UserProducts.jsx";
import ResetPassword from "./../common/ResetPassword";
import UserValidationErrorsSummaryText from "./common/UserValidationErrorsSummaryText.jsx";
import UserContact from "./common/UserContact.jsx";
import CheckBox from "../../controls/CheckBox.jsx";
import classNames from "classnames";
import Actions from "../../actions/PersonnelActions";
import ValidationHelper from "../../utilities/ValidationHelper";

const IsActiveCheckBox = ({ isActive, setIsActive }) => {
    const _handleActiveChange = (e) => {
        const checked = e.target.checked;
        setIsActive(checked);
    };
    return (
        <div id="IsActiveCheckbox" style={{ position: "absolute", top: "-52px", left: "150px" }}>
            <CheckBox id="cbIsActive" checked={isActive} onChange={_handleActiveChange}
                title="Active"/>
        </div>
    );
};

export class EditUserInfo extends Component {
    constructor (props) {
        super(props);

        this.state = {
            emailIsValid: true,
            phoneIsValid: true,
            lastNameIsValid: true,
            firstNameIsValid: true,
        };

        this.setUserContactNumber = this.setUserContactNumber.bind(this);
        this.setUserEmail = this.setUserEmail.bind(this);
        this._handlePhoneNumberOnFocus = this._handlePhoneNumberOnFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this._handlePhoneNumberOnFocus = this._handlePhoneNumberOnFocus.bind(this);
        this._handleEmailOnFocus = this._handleEmailOnFocus.bind(this);
        this.onProductClick = this.onProductClick.bind(this);
        this.onSelectRole = this.onSelectRole.bind(this);
        this.setIsActive = this.setIsActive.bind(this);
    }

    Ellipsis (field) {
        if (field && field.length > 25) {
            const fieldSubtract = field.substring(0, 25);
            return <div title={field}>{fieldSubtract}&hellip;</div>;
        }
        return field;
    }

    setUserContactNumber (e) {
        const value = e.target.value;
        this.props.setPhone(value);
    }

    setUserEmail(e) {
        const value = e.target.value;
        this.props.setEmail(value);
    }

    onBlur () {
        const user = this.props.user;
        const state = this.state;
        if (ValidationHelper.isNullOrEmpty(user.firstName)) {
            state.firstNameIsValid = false;
        }

        if (ValidationHelper.isNullOrEmpty(user.lastName)) {
            state.lastNameIsValid = false;
        }

        if (!ValidationHelper.isNullOrEmpty(user.email)) {
            state.emailIsValid = ValidationHelper.isValidEmailFormat(this.props.user.email);
        }

        if (!ValidationHelper.isNullOrEmpty(user.phone)) {
            state.phoneIsValid = ValidationHelper.isValidPhoneNumber(this.props.user.phone);
        }

        this.setState(state);
    }

    _handlePhoneNumberOnFocus () {
        this.setState({ phoneIsValid: true });
        this.props.hideErrorSummary();
    }

    _handleEmailOnFocus() {
        this.setState({ emailIsValid: true });
        this.props.hideErrorSummary();
    }

    onProductClick (checked, productId) {
        this.props.selectProduct(checked, productId);
    }

    onSelectRole (productId, roleId, roleName) {
        this.props.selectRole(productId, roleId, roleName);
    }

    setIsActive () {
        const result = !this.props.user.isActive;
        this.props.setIsActive(result);
    }
    render () {
        const errorResult = this.props.validationResult;
        const classErrorsSummary = classNames("alert", "alert-danger", { "hidden": !errorResult.show });
        const user = this.props.user;

        return (
            <div id="UserSettings" className="col-md-12">
                <IsActiveCheckBox isActive={this.props.user.isActive} setIsActive={this.props.setIsActive}/>
                <div className={classErrorsSummary}
                    id="errorsSummary">
                    <UserValidationErrorsSummaryText validationObject={errorResult}/>
                </div>
                <div id="UserInfo" className="col-md-12 control-row">
                    <div className="col-md-4">
                        <div className="formControlTitle">First Name</div>
                        <span className="picker-hollow"
                            id="firstName">
                            {this.Ellipsis(user.firstName)}</span>
                    </div>
                    <div className="col-md-4">
                        <div className="formControlTitle">Last Name</div>
                        <span className="picker-hollow"
                            id="lastName">
                            {this.Ellipsis(user.lastName)}</span>
                    </div>
                    <div className="col-md-2">
                        <div className="formControlTitle">Site Id</div>
                        <span className="picker-hollow"
                            id="siteId">
                            {user.site}</span>
                    </div>
                    <div className="col-md-2">
                        <div className="formControlTitle">User Id</div>
                        <span className="picker-hollow"
                            id="userId">{user.login}</span>
                    </div>
                </div>

                <UserContact user={user} onEmailChange = {this.setUserEmail}
                    setUserContactNumber = {this.setUserContactNumber}
                    onBlur = {this.onBlur}
                    _handlePhoneNumberOnFocus = { this._handlePhoneNumberOnFocus }
                    _handleEmailOnFocus = {this._handleEmailOnFocus}
                    emailIsValid = {this.state.emailIsValid}
                    phoneIsValid = {this.state.phoneIsValid}
                />

                <UserProducts organizationProducts={this.props.productRoles}
                    userProducts={this.props.user.userProducts}
                    selectProduct = {this.onProductClick}
                    selectRole = {this.onSelectRole}
                />

                <ResetPassword visible={!!this.props.newPassword}
                    newPassword={this.props.newPassword} login={this.props.user.login}/>
            </div>
        );
    }
}

EditUserInfo.propTypes = {
    onCancel: PropTypes.func,
    hideErrorSummary: PropTypes.func
};

const mapStateToProps = state => ({
    products: state.personnelState.products,
    organization: state.organizationState.organization,
    productRoles: state.personnelState.productRoles,
    user: state.personnelState.user,
    newPassword: state.personnelState.newPassword
});

const mapDispatchToProps = (dispatch) => {
    return ({
        setEmail: (value) => dispatch(Actions.setField("email", value)),
        setPhone: (value) => dispatch(Actions.setField("phone", value)),
        setIsActive: (isActive) => dispatch(Actions.setIsActive(isActive)),
        selectProduct: (checked, productId) => dispatch(Actions.selectProduct(checked, productId)),
        selectRole: (productId, roleId, roleName) => dispatch(Actions.selectRole(productId, roleId, roleName)),
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(EditUserInfo);
